import React from 'react'
import "./header.css"
import CTA from "./CTA"
import ME from "../../assets/ji-01R8P_400x400.jpg"
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    
    <header>
      <div className="container header_container">
        <h5>Hello I'm</h5>
        <h1>Caden Smith</h1>
        <h5 className="text-light">Full-Stack Web Developer</h5>
      <CTA />
      <HeaderSocials />
 {/* <div className="me">
        <img className='logo' src={ME} alt="picture of myself" />
      </div>  */}
      <a href="#contact" className='scroll_down'>Scroll Down</a>
      </div>
    </header>
  )
}

export default Header